import { ProjectStatus } from "@enums/projectStatus.enum";
import { Model } from "@interfaces/model.interface";

export interface Project extends Model {
	clientId: number;
	description: string;
	displayName: string;
	expectedEndDate? : Date;
	expectedStartDate? : Date;
	name: string;
	projectStatus: ProjectStatus;
}

export class Project implements Project {	
	description = "";
	name = "";
	projectStatus = ProjectStatus.New;

	constructor(data?: Partial<Project>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}